import { AppState } from './../../../app.reducers';
import { Store } from '@ngrx/store';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { getIsSigningIn, getLoggedIn, getSignInFailed } from '../../../shared/auth/redux/auth.selectors';
import { AccountService } from './../../../shared/services/auth';
import { CustomValidators } from '../../../shared/validators/customvalidators';
import { CommunicationStateComponent } from '../../../shared/components/communication-state';
import { SignInRequest } from '../../../shared/models/auth';
import { LoginAction } from '../../../shared/auth/redux/auth.actions';
import { SubSink } from 'subsink';

@Component({
  templateUrl: './register.component.html',
  standalone: false
})
export class RegisterComponent implements OnInit, OnDestroy {

  signUpForm: UntypedFormGroup;
  isSubmitting = false;
  signUpFeedbackMessages: any[] = [];

  @ViewChild(CommunicationStateComponent, { static: true }) public communicationState: CommunicationStateComponent;

  private subs = new SubSink();

  constructor(private router: Router,
    private store: Store<AppState>,
    private _accountService: AccountService) {
  }

  ngOnInit() {
    this.initForms();

    this.store.select(getLoggedIn).subscribe(x => {
      if (x === true) {
        this.goToMain();
      }
    });

    this.store.select(getIsSigningIn).subscribe(x => {
      this.isSubmitting = x;
    });

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    this.store.select(getSignInFailed).subscribe(x => {
      this.handleError(null);
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  goToMain() {
    this.router.navigate(['useraccount/user/properties']);
  }

  private initForms() {
    this.signUpForm = new UntypedFormGroup({
      firstName: new UntypedFormControl(null, [Validators.required]),
      lastName: new UntypedFormControl(null, [Validators.required]),
      // firstName: new FormControl(null, [Validators.required, Validators.maxLength(50)]),
      // lastName: new FormControl(null, [Validators.required, Validators.maxLength(50)]),
      email: new UntypedFormControl(null, [Validators.required, CustomValidators.emailValidator, Validators.maxLength(100)]),
      password: new UntypedFormControl(null, [Validators.required]),
      confirmPassword: new UntypedFormControl(),
      invitationCode: new UntypedFormControl(null, [Validators.required]),
    });


    const password = this.signUpForm.controls['password'];
    const confirmPassword = this.signUpForm.controls['confirmPassword'];

    password.setValidators(Validators.compose([Validators.required, CustomValidators.passwordPolicy(password)]));

    confirmPassword.setValidators(Validators.compose([Validators.required, CustomValidators.equal(password)]));

    password.valueChanges.subscribe(() => confirmPassword.updateValueAndValidity());
  }

  onSignUp() {
    this.isSubmitting = true;
    this.communicationState.setStartState();
    this.subs.sink = this.signUp()
      .subscribe(() => {

        this.signIn();
        /*
              // Log the user in now that they are registered
              this.signIn()
                .takeUntil(this.ngOnDestroy$)
                .subscribe((response) => {
                  // let response = JSON.parse(res);
                  this._authService.setData(response.access_token, response.userName, response.userRole);
                  // new AuthCompleteAction({ userName: response.userName, isAuthorized: true });

                  this.signUpForm.reset();
                  this.isSubmitting = false;
                  this.goToMain();

                }, (error) => this.handleError(error));
              */

      }, (error) => this.handleError(error));
  }

  signUp() {
    this.signUpFeedbackMessages = [];

    const payload = {
      firstName: this.signUpForm.value.firstName,
      lastName: this.signUpForm.value.lastName,
      email: this.signUpForm.value.email,
      password: this.signUpForm.value.password,
      confirmPassword: this.signUpForm.value.confirmPassword,
      invitationCode: this.signUpForm.value.invitationCode
    };

    return this._accountService.register(payload);
  }

  signIn() {

    const request: SignInRequest = {
      // grant_type: 'password',
      email: this.signUpForm.value.email,
      password: this.signUpForm.value.password,
      isPersistent: true,
      rememberBrowser: true
    };

    this.store.dispatch(new LoginAction(request));
  }

  private handleError(errors) {
    this.isSubmitting = false;
    this.signUpFeedbackMessages = errors;
    this.communicationState.setFailedState(errors);
  }
}
